import lodash from 'lodash';

export const formatDataForSelect = (data, labelProperty, valueProperty, typeProperty) => {
    return lodash.map(data, data => {
        return {
            label: lodash.get(data, labelProperty),
            value: lodash.get(data, valueProperty),
            type: lodash.get(data, typeProperty),
        };
    });
};

export const formatDataForSelectWithRoles = (data, labelProperty, valueProperty, disabledProperty) => {
    return lodash.map(data, data => {
        return {
            label: lodash.get(data, labelProperty),
            value: lodash.get(data, valueProperty),
            isDisabled: lodash.get(data, disabledProperty),
        };
    });
};

export const pluralize = (value, count) => count > 1 ? `${value}s` : value;
